// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Content from "../../content/about-us/history.json"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import Container from "../../components/layout/container"

const HistoryMobile = ({ langKey }) => {
  const { title, content } = Content[langKey]
  return (
    <div sx={{ backgroundColor: colors.code.secondary, marginBottom: `-1rem` }}>
      <Container>
        <div
          sx={{
            paddingTop: `3rem`,
            paddingBottom: `3rem`,
          }}
        >
          <div>
            <h2
              sx={{
                color: colors.white,
                fontWeight: fontWeights.black,
              }}
            >
              {title}
            </h2>
            <p sx={{ color: colors.white, fontSize: `0.94rem` }}>{content}</p>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default HistoryMobile
